import { extendZodWithOpenApi } from '@anatine/zod-openapi'
import z from 'zod'
import { Brand } from '../../shared'

extendZodWithOpenApi(z)

export const SendEventRequestSchema = z.object({
  idempotentId: z.string().uuid(),
  userId: z.string().uuid(),
  brand: z.nativeEnum(Brand),
  // TODO: Add event types in later
  eventName: z.string().min(1).max(100),
  attributes: z.record(z.unknown()).default({}),
})

export type SendEventRequest = z.infer<typeof SendEventRequestSchema>

export interface EventRecord<TName extends string, TData> {
  name: TName
  key: string
  data: TData
}
